"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7516],{

/***/ 95839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SignUpForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Check.js
var Check = __webpack_require__(41959);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./src/lib/bugsnag.js
var bugsnag = __webpack_require__(45817);
// EXTERNAL MODULE: ./src/lib/mailjet/index.ts
var mailjet = __webpack_require__(659);
// EXTERNAL MODULE: ./src/lib/mouseflow/index.js
var mouseflow = __webpack_require__(42325);
// EXTERNAL MODULE: ./src/lib/yup.ts
var yup = __webpack_require__(33448);
// EXTERNAL MODULE: ./src/qualification/hooks/useBreakpoints.ts
var useBreakpoints = __webpack_require__(19916);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
;// CONCATENATED MODULE: ./src/shared/components/Formik/FormikCheckbox.tsx









var FormikCheckbox = function(_param) {
    var label = _param.label, name = _param.name, checkboxProps = (0,_object_without_properties/* default */.Z)(_param, [
        "label",
        "name"
    ]);
    var _ref = (0,formik_esm/* useField */.U$)(name), __ref = (0,_sliced_to_array/* default */.Z)(_ref, 2), value = __ref[0].value, ref = __ref[1], error = ref.error, touched = ref.touched, formikFieldProps = (0,_object_without_properties/* default */.Z)(_ref[0], [
        "value"
    ]);
    var showError = Boolean(error && touched);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formikFieldProps), {
                    "aria-checked": value,
                    checked: value
                }), checkboxProps)),
                label: label
            }),
            showError && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* FormHelperText */.Q6, {
                error: true,
                children: error
            })
        ]
    });
};
/* harmony default export */ var Formik_FormikCheckbox = (FormikCheckbox);

// EXTERNAL MODULE: ./src/shared/components/FormikFormField.js + 2 modules
var FormikFormField = __webpack_require__(3317);
;// CONCATENATED MODULE: ./src/hub/components/ArticlePage/SignupForm.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: ",
        "px;\n  align-items: center;\n  margin-top: ",
        "px;\n\n  ",
        " {\n    gap: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .hc-form-control {\n    margin: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    border-radius: ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-direction: column;\n  width: 100%;\n  gap: ",
        "px;\n\n  div {\n    width: 100%;\n  }\n\n  margin-bottom: ",
        "px;\n\n  ",
        " {\n    flex-direction: row;\n    gap: ",
        "px;\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 52px; // So it's the same height as the input field next to it.\n  ",
        " {\n    width: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  cursor: pointer;\n  display: contents;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  background-color: ",
        ";\n\n  padding: ",
        ";\n  margin-bottom: ",
        "px;\n  width: 100%;\n  border-radius: ",
        "px;\n  color: ",
        ";\n\n  ",
        " {\n    margin-left: 0;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}















var FORM_ID = "sign-up-form";
var createFormSchema = function(t) {
    return yup/* default.object */.Z.object({
        email: yup/* default.string */.Z.string().required(t("common:signUpForm.emailRequired")).email(t("common:signUpForm.correctFormatEmail")),
        acceptSubscription: yup/* default.bool */.Z.bool().oneOf([
            true
        ], t("common:validations.required")).required()
    });
};
var DEFAULT_FORM_VALUES = {
    email: "",
    acceptSubscription: false
};
function SignUpForm(param) {
    var imageSrc = param.imageSrc, title = param.title, buttonText = param.buttonText, subTitle = param.subTitle, successFeedback = param.successFeedback, contactListId = param.contactListId;
    var t = (0,useTranslation/* useTranslation */.$)("hub").t;
    var mobile = (0,useBreakpoints/* useBreakpointDown */.a)("sm");
    var ref = (0,react.useState)(null), submissionResult = ref[0], setSumbissionResult = ref[1];
    var closeFeedbackMessageTimeoutRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!submissionResult) {
            return;
        }
        closeFeedbackMessageTimeoutRef.current = setTimeout(function() {
            setSumbissionResult(null);
        }, 6000);
        return function() {
            if (closeFeedbackMessageTimeoutRef.current) {
                clearTimeout(closeFeedbackMessageTimeoutRef.current);
            }
        };
    }, [
        submissionResult
    ]);
    var hasImage = !!imageSrc;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "column",
        children: [
            hasImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    alt: "",
                    src: imageSrc,
                    width: 690,
                    height: 280,
                    objectFit: "cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                        mb: {
                            xs: 3,
                            md: 2
                        },
                        textAlign: "left",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "h3",
                                lineHeight: "146%",
                                mb: {
                                    xs: 2,
                                    md: 2
                                },
                                mt: 2,
                                fontSize: {
                                    xs: "24px",
                                    md: "24px"
                                },
                                children: title || t("common:signUpForm.title")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                variant: "body2",
                                gutterBottom: true,
                                children: subTitle || t("common:signUpForm.subtitle")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                        initialValues: DEFAULT_FORM_VALUES,
                        validationSchema: createFormSchema(t),
                        onSubmit: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(values, actions) {
                                var e;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                3,
                                                4
                                            ]);
                                            setSumbissionResult(null);
                                            mouseflow/* Mouseflow.notify.formSubmitAttempt */.s.notify.formSubmitAttempt(FORM_ID);
                                            return [
                                                4,
                                                (0,mailjet/* contactListSubscribe */.m)(values.email, contactListId)
                                            ];
                                        case 1:
                                            _state.sent();
                                            mouseflow/* Mouseflow.notify.formSubmitSuccess */.s.notify.formSubmitSuccess(FORM_ID);
                                            setSumbissionResult("success");
                                            return [
                                                3,
                                                4
                                            ];
                                        case 2:
                                            e = _state.sent();
                                            if ((0,_instanceof/* default */.Z)(e, Error)) {
                                                mouseflow/* Mouseflow.notify.formSubmitFailure */.s.notify.formSubmitFailure(FORM_ID);
                                                bugsnag/* default.notify */.Z.notify(e);
                                            }
                                            setSumbissionResult("failure");
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            actions.setSubmitting(false);
                                            actions.resetForm({
                                                values: DEFAULT_FORM_VALUES
                                            });
                                            return [
                                                7
                                            ];
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(values, actions) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        enableReinitialize: true,
                        children: function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledForm, {
                                id: FORM_ID,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                        variant: mobile ? "label" : "srOnly",
                                        component: "label",
                                        fontSize: {
                                            xs: 12
                                        },
                                        fontWeight: 500,
                                        htmlFor: "email",
                                        ml: 1,
                                        children: "Email *"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputAndButtonWrapper, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                                maxWidth: "600px",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                                                    placeholder: "Email",
                                                    name: "email",
                                                    id: "email",
                                                    type: "email",
                                                    component: FormikFormField/* default */.Z
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                                                size: "lg",
                                                variant: "primary",
                                                type: "submit",
                                                role: "button",
                                                "aria-label": "submit",
                                                id: "contact-caterer-modal-submit",
                                                children: buttonText || t("common:signUpForm.button")
                                            })
                                        ]
                                    }),
                                    submissionResult && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        alignSelf: "center",
                                        children: submissionResult === "success" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledBox, {
                                            $type: "success",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {
                                                    color: "inherit"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                    variant: "caption",
                                                    color: "inherit",
                                                    ml: 1,
                                                    children: successFeedback || t("common:signUpForm.successMessage")
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBox, {
                                            $type: "failure",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                variant: "caption",
                                                color: "inherit",
                                                ml: 1,
                                                children: t("common:signUpForm.errorMessage")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Formik_FormikCheckbox, {
                                            name: "acceptSubscription",
                                            size: "small",
                                            role: "checkbox",
                                            "aria-label": "Checkbox",
                                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                                variant: "body2",
                                                fontSize: {
                                                    xs: 12,
                                                    md: 14
                                                },
                                                pt: 0.25,
                                                pl: 1,
                                                children: t("common:signUpForm.checkboxLabel")
                                            })
                                        })
                                    })
                                ]
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterSocialLinks, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                href: "https://www.facebook.com/heycater",
                                target: "_blank",
                                rel: "noopener",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "facebook logo",
                                    src: "/artifacts/images/hub/socials/facebook.svg",
                                    width: 40,
                                    height: 40
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                href: "https://www.linkedin.com/company/heycater/",
                                target: "_blank",
                                rel: "noopener",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "linkedin logo",
                                    src: "/artifacts/images/hub/socials/linkedin.svg",
                                    width: 40,
                                    height: 40
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                href: "https://www.instagram.com/heycater/",
                                target: "_blank",
                                rel: "noopener",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    alt: "instagram logo",
                                    src: "/artifacts/images/hub/socials/instagram.svg",
                                    width: 40,
                                    height: 40
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Typography */.ZT, {
                                fontWeight: 500,
                                variant: "caption",
                                children: t("cta.ctaSignupSocialsText")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        })
                    })
                ]
            })
        ]
    });
}
var FooterSocialLinks = styled_components_browser_esm/* default.div */.ZP.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(5);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});
var StyledForm = (0,styled_components_browser_esm/* default */.ZP)(formik_esm/* Form */.l0)(_templateObject1());
var ImageWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), function(props) {
    return props.theme.spacing(3);
});
var ContentWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3());
var InputAndButtonWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), function(props) {
    return props.theme.spacing(1);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(3);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
}, function(props) {
    return props.theme.spacing(2);
}, function(param) {
    var theme = param.theme;
    return theme.spacing(2);
});
var StyledButton = (0,styled_components_browser_esm/* default */.ZP)(esm/* Button */.zx)(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("sm");
});
var FooterSocialIconLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject6());
var StyledBox = styled_components_browser_esm/* default.div */.ZP.div(_templateObject7(), function(param) {
    var theme = param.theme, $type = param.$type;
    return $type === "success" ? theme.palette.secondary.light : theme.palette.error.light;
}, function(props) {
    return props.theme.spacing(1, 1, 1, 1);
}, function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.spacing(1);
}, function(props) {
    return props.theme.palette.common.white;
}, function(props) {
    return props.theme.breakpoints.down("sm");
});


/***/ }),

/***/ 55352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ embeddedAssetOptions; },
/* harmony export */   "l": function() { return /* binding */ getContentfulImageUrl; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74129);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80865);
/* harmony import */ var _heycater_design_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95197);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85444);
/* harmony import */ var hub_components_ArticlePage_SignupForm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95839);
/* eslint-disable react/display-name */ 




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: ",
        "px auto;\n\n  ",
        " {\n    &:first-child {\n      margin-top: ",
        "px;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var Accordion = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6649), __webpack_require__.e(1555)]).then(__webpack_require__.bind(__webpack_require__, 31555));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31555)
            ];
        }
    }
});
var ContentfulButton = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 7518).then(__webpack_require__.bind(__webpack_require__, 57518));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57518)
            ];
        }
    }
});
var ContentfulImage = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 9635).then(__webpack_require__.bind(__webpack_require__, 79635));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79635)
            ];
        }
    }
});
var ExpertSection = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 1820).then(__webpack_require__.bind(__webpack_require__, 81820));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81820)
            ];
        }
    }
});
var HTMLSnippet = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 2016).then(__webpack_require__.bind(__webpack_require__, 52016));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52016)
            ];
        }
    }
});
var HubBanner = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 732).then(__webpack_require__.bind(__webpack_require__, 60732));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60732)
            ];
        }
    }
});
var ImageGallery = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 9915).then(__webpack_require__.bind(__webpack_require__, 9915));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9915)
            ];
        }
    }
});
var VideoEmbed = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 8650).then(__webpack_require__.bind(__webpack_require__, 28650));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28650)
            ];
        }
    }
});
var Testimonials = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 1514).then(__webpack_require__.bind(__webpack_require__, 91514));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91514)
            ];
        }
    }
});
var FullWidthMedia = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 6419).then(__webpack_require__.bind(__webpack_require__, 96419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96419)
            ];
        }
    }
});
var HeroFunnel = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4566), __webpack_require__.e(4872), __webpack_require__.e(3992), __webpack_require__.e(9648), __webpack_require__.e(5643), __webpack_require__.e(6888), __webpack_require__.e(7317), __webpack_require__.e(3205)]).then(__webpack_require__.bind(__webpack_require__, 5401));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(5401)
            ];
        }
    }
});
var ImageGalleryWithCaption = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 192).then(__webpack_require__.bind(__webpack_require__, 40192));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40192)
            ];
        }
    }
});
var ImageTextFlexBox = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 6588).then(__webpack_require__.bind(__webpack_require__, 76588));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76588)
            ];
        }
    }
});
var MPPreviewCards = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8406), __webpack_require__.e(7010), __webpack_require__.e(6518)]).then(__webpack_require__.bind(__webpack_require__, 57813));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57813)
            ];
        }
    }
});
var Services = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 6714).then(__webpack_require__.bind(__webpack_require__, 46714));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(46714)
            ];
        }
    }
});
var TitleWithCaption = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 7256).then(__webpack_require__.bind(__webpack_require__, 77256));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77256)
            ];
        }
    }
});

function getContentfulImageUrl(contentfulImage) {
    return "https:".concat(contentfulImage.fields.file.url);
}
function embeddedAssetOptions() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        ratings: undefined
    };
    var ratings = props === null || props === void 0 ? void 0 : props.ratings;
    var _obj;
    return {
        renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__/* .BLOCKS.EMBEDDED_ENTRY */ .RG.EMBEDDED_ENTRY, function(node) {
            var contentType = node.data.target.sys.contentType.sys.id;
            if (contentType === "imageGallery") {
                var fields = node.data.target.fields;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageGallery, {
                    images: fields.images.map(function(image) {
                        return {
                            src: getContentfulImageUrl(image),
                            alt: image.fields.description
                        };
                    })
                });
            }
            if (contentType === "hubBanner") {
                var fields1 = node.data.target.fields;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(BlockEntryWrapper, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HubBanner, {
                        title: fields1.titleContent,
                        button: {
                            text: fields1.buttonText,
                            url: fields1.url
                        },
                        subtitle: fields1.subtitle,
                        image: fields1.image ? {
                            src: getContentfulImageUrl(fields1.image),
                            alt: ""
                        } : undefined
                    })
                });
            }
            if (contentType === "htmlSnippet") {
                var fields2 = node.data.target.fields;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HTMLSnippet, {
                    htmlSnippet: fields2.htmlSnippet
                });
            }
            if (contentType === "personCta") {
                var fields3 = node.data.target.fields;
                var personFields = fields3.person.fields;
                var description = fields3.description || (personFields === null || personFields === void 0 ? void 0 : personFields.description);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    maxWidth: 1050,
                    mx: "auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ExpertSection, {
                        my: 4,
                        ctaLabel: fields3.ctaText,
                        ctaLink: fields3.ctaUrl,
                        description: description || "",
                        imageSrc: getContentfulImageUrl(personFields.avatar),
                        name: personFields.name,
                        title: fields3.title
                    })
                });
            }
            if (contentType === "embeddedQualificationFunnel") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(HeroFunnel, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, node.data.target.fields), {
                    ratings: ratings
                }));
            }
            if (contentType === "contactForm") {
                var contactForm = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, node.data.target.fields);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    maxWidth: 800,
                    mx: "auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(hub_components_ArticlePage_SignupForm__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        imageSrc: contactForm.image ? getContentfulImageUrl(contactForm.image) : undefined,
                        title: contactForm.title,
                        buttonText: contactForm.buttonText,
                        subTitle: contactForm.subtitle,
                        successFeedback: contactForm.successFeedback,
                        contactListId: contactForm.contactList.fields.id
                    })
                });
            }
            if (contentType === "titleWithCaption") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleWithCaption, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, node.data.target.fields));
            }
            if (contentType === "imageGalleryWithCaption") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageGalleryWithCaption, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, node.data.target.fields));
            }
            if (contentType === "imageTextFlexBox") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImageTextFlexBox, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, node.data.target.fields));
            }
            if (contentType === "services") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Services, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, node.data.target.fields));
            }
            if (contentType === "mpPreviewCards") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(MPPreviewCards, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, node.data.target.fields));
            }
            if (contentType === "fullWidthMedia") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FullWidthMedia, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, node.data.target.fields));
            }
            if (contentType === "testimonialList") {
                var _fields = node.data.target.fields, _testimonials = _fields.testimonials, testimonials = _testimonials === void 0 ? [] : _testimonials;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    maxWidth: 1050,
                    mx: "auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Testimonials, {
                        items: testimonials.map(function(param) {
                            var testimonial = param.fields;
                            var ref, ref1;
                            return {
                                imageSrc: testimonial.image ? getContentfulImageUrl(testimonial.image) : "",
                                body: testimonial.body,
                                company: {
                                    name: testimonial.company,
                                    image: testimonial.companyLogo ? {
                                        src: getContentfulImageUrl(testimonial.companyLogo),
                                        height: (ref = testimonial.companyLogo.fields.file.details.image) === null || ref === void 0 ? void 0 : ref.height,
                                        width: (ref1 = testimonial.companyLogo.fields.file.details.image) === null || ref1 === void 0 ? void 0 : ref1.width
                                    } : undefined
                                },
                                title: testimonial.title,
                                name: testimonial.name
                            };
                        })
                    })
                });
            }
            if (contentType === "testimonial") {
                var ref, ref1;
                var testimonial = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, node.data.target.fields);
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    maxWidth: 1050,
                    mx: "auto",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Testimonials, {
                        items: [
                            {
                                imageSrc: getContentfulImageUrl(testimonial.image),
                                body: testimonial.body,
                                company: {
                                    name: testimonial.company,
                                    image: testimonial.companyLogo ? {
                                        src: getContentfulImageUrl(testimonial.companyLogo),
                                        height: (ref = testimonial.companyLogo.fields.file.details.image) === null || ref === void 0 ? void 0 : ref.height,
                                        width: (ref1 = testimonial.companyLogo.fields.file.details.image) === null || ref1 === void 0 ? void 0 : ref1.width
                                    } : undefined
                                },
                                title: testimonial.title,
                                name: testimonial.name
                            }, 
                        ]
                    })
                });
            }
            if (contentType === "faqList") {
                var fields4 = node.data.target.fields;
                var faqs = fields4.items;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    maxWidth: 1050,
                    mx: "auto",
                    children: faqs.map(function(faq) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Accordion, {
                            details: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_3__/* .documentToReactComponents */ .h)(faq.fields.answer),
                            summary: faq.fields.question
                        }, faq.sys.id);
                    })
                });
            }
            if (contentType === "button") {
                var fields5 = node.data.target.fields;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentfulButton, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, fields5));
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__/* .BLOCKS.HEADING_1 */ .RG.HEADING_1, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                width: "100%",
                maxWidth: 1050,
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    as: "h1",
                    children: children
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__/* .BLOCKS.HEADING_2 */ .RG.HEADING_2, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                width: "100%",
                maxWidth: 1050,
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    as: "h2",
                    children: children
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__/* .BLOCKS.HEADING_3 */ .RG.HEADING_3, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                width: "100%",
                maxWidth: 1050,
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    as: "h3",
                    children: children
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__/* .BLOCKS.HEADING_4 */ .RG.HEADING_4, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                width: "100%",
                maxWidth: 1050,
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    as: "h4",
                    children: children
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__/* .BLOCKS.HEADING_5 */ .RG.HEADING_5, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                width: "100%",
                maxWidth: 1050,
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    as: "h5",
                    children: children
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__/* .BLOCKS.HEADING_6 */ .RG.HEADING_6, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                width: "100%",
                maxWidth: 1050,
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    as: "h6",
                    children: children
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__/* .BLOCKS.PARAGRAPH */ .RG.PARAGRAPH, function(_node, children) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                maxWidth: 1050,
                mx: "auto",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_heycater_design_system__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, {
                    as: "p",
                    children: children
                })
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__/* .BLOCKS.EMBEDDED_ASSET */ .RG.EMBEDDED_ASSET, function(node) {
            var file = node.data.target.fields.file;
            var contentType = file.contentType;
            var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(contentType.split("/"), 1), mimeGroup = ref[0];
            if (mimeGroup === "image") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentfulImage, {
                    src: node.data.target,
                    width: file.details.image.width,
                    height: file.details.image.height,
                    layout: "responsive"
                });
            }
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_4__/* .INLINES.HYPERLINK */ .Ev.HYPERLINK, function(node) {
            var url = node.data.uri;
            if (url.includes("vimeo.com") || url.includes("youtube.com") || url.includes("youtu.be")) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(VideoEmbed, {
                    url: url
                });
            }
            //@ts-expect-error TODO: figure out what happens here
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                href: url,
                children: node.content[0].value
            });
        }), _obj)
    };
}
var BlockEntryWrapper = styled_components__WEBPACK_IMPORTED_MODULE_12__/* ["default"].div */ .ZP.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(4);
}, function(param) {
    var theme = param.theme;
    return theme.breakpoints.up("md");
}, function(param) {
    var theme = param.theme;
    return theme.spacing(0);
});


/***/ }),

/***/ 659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ contactListSubscribe; }
/* harmony export */ });
/* unused harmony export NEWSLETTER_CONTACT_LIST_ID */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);


var NEWSLETTER_CONTACT_LIST_ID = 179340;
var contactListSubscribe = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(email, contactListId) {
        var body, response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    body = {
                        email: email,
                        contactListId: contactListId
                    };
                    return [
                        4,
                        fetch("/api/next/subscribe", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify(body)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (response.ok) {
                        return [
                            2,
                            response.json()
                        ];
                    } else {
                        throw new Error(response.statusText);
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function contactListSubscribe(email, contactListId) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 42325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ Mouseflow; }
/* harmony export */ });
// Source: https://help.mouseflow.com/en/articles/4274450-forms-with-no-successful-submits
var FORM_SUBMIT_ATTEMPT = "formSubmitAttempt";
var FORM_SUBMIT_SUCCESS = "formSubmitSuccess";
var FORM_SUBMIT_FAILURE = "formSubmitFailure";
function mouseflowNotify(type, htmlId) {
    if (typeof htmlId !== "string") {
        return;
    }
    if (!window._mfq) {
        window._mfq = [];
    }
    window._mfq.push([
        type,
        "#".concat(htmlId)
    ]);
}
var Mouseflow = {
    notify: {
        formSubmitAttempt: function formSubmitAttempt(formId) {
            mouseflowNotify(FORM_SUBMIT_ATTEMPT, formId);
        },
        formSubmitSuccess: function formSubmitSuccess(formId) {
            mouseflowNotify(FORM_SUBMIT_SUCCESS, formId);
        },
        formSubmitFailure: function formSubmitFailure(formId) {
            mouseflowNotify(FORM_SUBMIT_FAILURE, formId);
        }
    }
};


/***/ }),

/***/ 3317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_FormikFormField; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
;// CONCATENATED MODULE: ./src/shared/hooks/useFormikFormField.js


function useFormikFormField(param) {
    var field = param.field, _form = param.form, errors = _form.errors, touched = _form.touched, helperText = param.helperText;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var fieldError = (0,formik_esm/* getIn */.u9)(errors, field.name);
    var showError = (0,formik_esm/* getIn */.u9)(touched, field.name) && !!fieldError;
    var formHelperText = showError && t(fieldError) || helperText;
    return {
        showError: showError,
        formHelperText: formHelperText
    };
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js + 12 modules
var TextField = __webpack_require__(77269);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
;// CONCATENATED MODULE: ./src/system/components/Textarea.js


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n\n  .MuiFilledInput-root {\n    border-radius: 8px;\n    padding: 12px;\n    background-color: ",
        ";\n    border: 1px solid transparent;\n    line-height: ",
        ";\n\n    &:hover {\n      background-color: ",
        ";\n      border: 1px solid ",
        ";\n    }\n\n    &:active,\n    &:focus,\n    &:focus-visible,\n    &.Mui-focused {\n      border: 1px solid ",
        ";\n    }\n  }\n\n  .MuiFilledInput-underline:before {\n    border-bottom: none;\n  }\n  .MuiFilledInput-underline:after {\n    border-bottom: none;\n  }\n\n  .MuiInputBase-inputMultiline {\n    cursor: auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Textarea = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTextarea, (0,_object_spread/* default */.Z)({
        ref: ref,
        multiline: true,
        rows: 4,
        variant: "filled"
    }, props));
});
Textarea.displayName = "Textarea";
var StyledTextarea = (0,styled_components_browser_esm/* default */.ZP)(TextField/* default */.Z)(_templateObject(), function(props) {
    return props.theme.palette.text.disabled;
}, function(props) {
    return props.theme.typography.body1.lineHeight;
}, function(props) {
    return props.theme.palette.text.disabled;
}, function(props) {
    return props.theme.palette.grey[400];
}, function(props) {
    return props.theme.palette.grey[600];
});
/* harmony default export */ var components_Textarea = (Textarea);

;// CONCATENATED MODULE: ./src/shared/components/FormikFormField.js







function FormikFormField(param) {
    var field = param.field, form = param.form, helperText = param.helperText, _label = param.label, label = _label === void 0 ? "" : _label, _placeholder = param.placeholder, placeholder = _placeholder === void 0 ? "" : _placeholder, _required = param.required, required = _required === void 0 ? false : _required, _type = param.type, type = _type === void 0 ? "text" : _type, _autocomplete = param.autocomplete, autocomplete = _autocomplete === void 0 ? "off" : _autocomplete, _multiline = param.multiline, multiline = _multiline === void 0 ? false : _multiline, inputRef = param.inputRef;
    var ref = useFormikFormField({
        field: field,
        form: form,
        helperText: helperText
    }), formHelperText = ref.formHelperText, showError = ref.showError;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* FormControl */.NI, {
        error: showError,
        required: required,
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InputLabel */.AZ, {
                htmlFor: field.name,
                children: label
            }),
            multiline ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Textarea, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                autoComplete: autocomplete,
                placeholder: placeholder,
                ref: inputRef
            })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Input */.II, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, field), {
                type: type,
                autoComplete: autocomplete,
                placeholder: placeholder,
                ref: inputRef
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* FormHelperText */.Q6, {
                children: formHelperText
            })
        ]
    });
}
/* harmony default export */ var components_FormikFormField = (FormikFormField);


/***/ }),

/***/ 89452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ PageLayout; },
  "Z": function() { return /* binding */ layouts_MainLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Facebook.js
var Facebook = __webpack_require__(83792);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LinkedIn.js
var LinkedIn = __webpack_require__(20551);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Twitter.js
var Twitter = __webpack_require__(44704);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(85444);
// EXTERNAL MODULE: ./src/shared/components/CookieContextProvider.tsx + 1 modules
var CookieContextProvider = __webpack_require__(82293);
// EXTERNAL MODULE: ./src/shared/components/Locale.js
var Locale = __webpack_require__(20486);
// EXTERNAL MODULE: ./src/shared/constants.ts
var constants = __webpack_require__(98769);
// EXTERNAL MODULE: ./src/shared/svg/Logo.js
var Logo = __webpack_require__(37582);
// EXTERNAL MODULE: ./src/system/components/Container.tsx
var Container = __webpack_require__(10758);
;// CONCATENATED MODULE: ./src/shared/layouts/Footer.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n  text-decoration: none;\n  display: flex;\n  align-items: start;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: inherit;\n  border: inherit;\n  line-height: 23px;\n  height: inherit;\n  color: inherit;\n  margin: ",
        "px;\n  font-size: 14px;\n  cursor: pointer;\n  display: inline-block;\n\n  text-decoration: none;\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  background: ",
        ";\n  color: white;\n  border: none;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-direction: ",
        ";\n  ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 0;\n  display: flex;\n\n  ",
        " {\n    margin: ",
        ";\n    display: flex;\n    text-decoration: none;\n    list-style: none;\n    padding: 0;\n    flex-direction: ",
        ";\n    align-items: center;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  margin: ",
        "px;\n  font-size: 14px;\n  display: inline-block;\n  cursor: pointer;\n  text-decoration: none;\n  ",
        " {\n    margin: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: inherit;\n  cursor: pointer;\n  margin: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #9cba6c;\n  text-decoration: none;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}














var YEAR = new Date().getFullYear();
function Footer() {
    var t = (0,useTranslation/* useTranslation */.$)("static_pages").t;
    var ref = (0,react.useContext)(CookieContextProvider/* CookieContext */.U), detailsOpen = ref.detailsOpen, setDetailsOpen = ref.setDetailsOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledFooter, {
            className: "main-footer",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                size: "md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumn, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                    alt: "",
                                    fill: "white"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterColumn, {
                                fontSize: 12,
                                color: "white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Locale/* default */.Z, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                                as: "nav",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "sr-only",
                                        children: "Social Links"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://www.linkedin.com/company/heycater/",
                                        "aria-label": "Linkedin",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedIn/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://www.facebook.com/heycater",
                                        "aria-label": "Facebook",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Facebook/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterSocialIconLink, {
                                        href: "https://twitter.com/HeyHeycater",
                                        "aria-label": "Twitter",
                                        target: "_blank",
                                        rel: "noopener",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter/* default */.Z, {
                                            fontSize: "small"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterWrapper, {
                        flexDirection: "column",
                        as: "nav",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterColumn, {
                            mobileColumn: true,
                            as: "ul",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/impressum",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.imprint")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/agb",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.terms")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/datenschutz",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.privacy")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                        as: "button",
                                        onClick: function() {
                                            return setDetailsOpen(!detailsOpen);
                                        },
                                        children: "Cookies"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: constants/* LINKS.career */.BA.career,
                                        rel: "noopener",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CareerLink, {
                                            target: "_blank",
                                            children: t("common:navigation.career")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/about-us",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: "About us"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/hub",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLink, {
                                            children: t("common:navigation.blog")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavListItem, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/caterer",
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FooterLink, {
                                            children: [
                                                "\uD83E\uDDD1‍\uD83C\uDF73 ",
                                                t("common:navigation.partner")
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTypography, {
                        pt: 2,
                        fontSize: 12,
                        children: [
                            YEAR,
                            " Hey Group GmbH"
                        ]
                    })
                ]
            })
        })
    });
}
var NavListItem = styled_components_browser_esm/* default.li */.ZP.li(_templateObject());
var StyledLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject1(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 0, 1);
});
var StyledFooter = styled_components_browser_esm/* default.div */.ZP.div(_templateObject2(), function(props) {
    return props.theme.spacing(4, 0);
}, function(props) {
    return props.theme.palette.text.primary;
});
var FooterWrapper = styled_components_browser_esm/* default.div */.ZP.div(_templateObject3(), function(props) {
    return props.flexDirection;
}, function(props) {
    return props.theme.breakpoints.down("xs");
});
var FooterColumn = styled_components_browser_esm/* default.div */.ZP.div(_templateObject4(), function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(1, 0);
}, function(props) {
    return props.mobileColumn ? "column" : "row";
});
var FooterLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject5(), function(props) {
    return props.theme.spacing(2);
}, function(props) {
    return props.theme.breakpoints.down("xs");
}, function(props) {
    return props.theme.spacing(0, 0, 1);
});
var FooterSocialIconLink = styled_components_browser_esm/* default.a */.ZP.a(_templateObject6(), function(props) {
    return props.theme.spacing(0, 1.75);
});
var StyledTypography = (0,styled_components_browser_esm/* default */.ZP)(esm/* Typography */.ZT)(_templateObject7(), function(props) {
    return props.theme.palette.grey[400];
});
var CareerLink = (0,styled_components_browser_esm/* default */.ZP)(FooterLink)(_templateObject8());
/* harmony default export */ var layouts_Footer = (Footer);

// EXTERNAL MODULE: ./src/shared/layouts/Navigation.tsx + 3 modules
var Navigation = __webpack_require__(93054);
;// CONCATENATED MODULE: ./src/shared/layouts/MainLayout.tsx






function MainLayout(param) {
    var children = param.children, _hideNavigationLinks = param.hideNavigationLinks, hideNavigationLinks = _hideNavigationLinks === void 0 ? false : _hideNavigationLinks, _hideNavbar = param.hideNavbar, hideNavbar = _hideNavbar === void 0 ? false : _hideNavbar, renderNavbarCta = param.renderNavbarCta, ratings = param.ratings;
    if (hideNavbar) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
            main: children,
            footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_Footer, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLayout, {
        header: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navigation/* default */.Z, {
            ratings: ratings,
            hideNavigationLinks: hideNavigationLinks,
            renderCTA: renderNavbarCta
        }),
        main: children,
        footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_Footer, {})
    });
}
MainLayout.propTypes = {
    children: prop_types_default().oneOfType([
        prop_types_default().arrayOf((prop_types_default()).node),
        (prop_types_default()).node, 
    ]).isRequired
};
var PageLayout = function(param) {
    var header = param.header, main = param.main, footer = param.footer, root = param.root;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Box */.xu, {
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        position: "sticky",
                        top: "0",
                        zIndex: "100",
                        children: header
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        as: "main",
                        display: "flex",
                        overflow: "clip",
                        flexDirection: "column",
                        flexGrow: "1",
                        children: main
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Box */.xu, {
                        as: "footer",
                        mt: "auto",
                        children: footer
                    })
                ]
            }),
            root
        ]
    });
};
/* harmony default export */ var layouts_MainLayout = (MainLayout);


/***/ })

}]);